import React, { useState } from 'react';

//Header Data
import headerLogo from '../assets/desall_logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons';

//Assets
import creative from '../assets/creative_placeholder.png';
import footerImg from '../assets/footer_placeholder_transparent.png';

//Components
import AppFooter from '../components/AppFooter/AppFooter';
import { useForm } from 'react-hook-form';
import { SocialToken, SignupCreateFilter, SignUpForm } from '../global';
import axiosHelper from '../helpers/axiosHelper';
import SignupCard from '../components/SignupCard/SignupCard';
import { getFooterMenu, getHeaderMenu } from '../store/Selectors';
import { useStoreState } from 'pullstate';
import { Modal } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { faCircleExclamation, faXmark } from '@fortawesome/free-solid-svg-icons';
import styles from './signup.module.scss';

import { IResolveParams, LoginSocialFacebook, LoginSocialGoogle, objectType } from 'reactjs-social-login';
import { useAuth } from '../context/AuthContext';
import { ROUTEPATHS } from './routePaths';
import { setSocialResolve, setSocialUser } from '../store/DesallStore';
import DslStore from '../store/DslStore';
import { useBanner } from '../context/BannerContext';
import AppHeaderWLF from '../components/AppHeader/AppHeaderWLF';
import FormField from '../components/Forms/FormField';
import { validateEmail, validateUsername } from '../helpers/validators';

const SignupPage: React.FC = () => {
  const { tokLogin } = useAuth();
  const { createAndAddBannerMessage } = useBanner();
  const footerMenu = useStoreState(DslStore, getFooterMenu);
  const headerMenu = useStoreState(DslStore, getHeaderMenu);
  const [userType, setUserType] = useState('D');
  const [clientModalVisible, setClientModalVisible] = useState(false);

  const params = useParams();
  const navigate = useNavigate();

  // let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})');
  // let mediumPassword = new RegExp('((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))');
  // let strengthBadge = document.getElementById('StrengthDisp');

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm<SignUpForm>({ mode: 'onBlur', reValidateMode: 'onBlur' });

  const selectDesigner = () => {
    setUserType('D');
  };

  const selectClient = () => {
    if (clientModalVisible) {
      setUserType('C');
      setClientModalVisible(false);
      return;
    }
    if (userType === 'D') {
      setUserType('C');
      setClientModalVisible(true);
      return;
    }
  };

  const onSubmit = async (data: SignUpForm) => {
    
    var formData: SignupCreateFilter = {
      username: data.username,
      email: data.email,
      cleartextPassword: data.password,
      userType: userType,
      receiveNewsletter: data.receiveNewsletter,
      hunterCode: params.huntercode ? params.huntercode : '',
    };
    
    console.log('🔵 Sending signup request with:', formData);
    
    const signupResponse = await axiosHelper.createUser(formData);
    console.log('🔵 Signup response:', signupResponse);
    if (!signupResponse) {
      return;
    }
    if (signupResponse.data) {
      const loginResult = await tokLogin(signupResponse.data.dslToken);
      console.log(loginResult);
      if (loginResult) {
        navigate(`/${ROUTEPATHS.COMMUNITY}/${loginResult.nameForURL}/profile-editable`);
      }
    }
    // checkPwd(data.password);

    // if (data.password === data.passwordrpt) {
    //   console.log('ciao');
    //   if (privacy) {
    //     console.log('ciao2');
    //     setFormValue(data);

    //     console.log(itemSelected);
    //     //   form!.email = data.email;
    //     //   form!.password = data.password;
    //     //   form!.username = data.username;
    //     //   console.log(form);
    //   }
    // }
  };

  // useEffect(() => {
  //   if (formValue && itemSelected === 'D') {
  //     signUpCallDesigner(formValue);
  //   } else if (formValue && itemSelected === 'C') {
  //     signUpCallClient(formValue);
  //   }
  // }, [formValue]);

  // const signUpCallDesigner = async (form: SignUpData) => {
  //   // setUsernameError(false);
  //   // console.log(form);
  //   // params.huntercode ? (form.hunterCode = params.huntercode) : (form.hunterCode = 'null');
  //   // form.userType = userType;
  //   // await axiosHelper
  //   //   .signUpDesigner(form)
  //   //   ?.then((response) => {
  //   //     console.log(response);
  //   //     setTimeout(async () => {
  //   //       const result = await login(email, pwd, true);
  //   //       // const result = await axiosHelper.loginDesigner<User>(email, pwd);
  //   //       if (result !== null) {
  //   //         navigate('/');
  //   //       }
  //   //     }, 2000);
  //   //   })
  //   //   .catch((error) => {
  //   //     console.log(error);
  //   //     setUsernameError(true);
  //   //   });
  // };

  // const signUpCallClient = async (form: SignUpData) => {
  //   // setUsernameError(false);
  //   // console.log(form);
  //   // params.huntercode ? (form.hunterCode = params.huntercode) : (form.hunterCode = 'null');
  //   // form.userType = userType;
  //   // await axiosHelper
  //   //   .signUpClient(form)
  //   //   ?.then((response) => {
  //   //     console.log(response);
  //   //     setTimeout(async () => {
  //   //       const result = await login(email, pwd, true);
  //   //       if (result !== null) {
  //   //         navigate(`/${ROUTEPATHS.COMMUNITY}/${result.nameForURL}/profile-editable`);
  //   //       }
  //   //     }, 2000);
  //   //   })
  //   //   .catch((error) => {
  //   //     console.log(error);
  //   //     setUsernameError(true);
  //   //   });
  // };
  const socialSignup = ({ provider, data }: IResolveParams) => {
    setSocialResolve({ provider, data });
    createAndAddBannerMessage(`You are signing up with ${provider}. Please wait...`);

    console.log('socialSignup', data);
  };

  const facebookSignUp = async (token: string, uid: string, email: string, firstName: string, lastName: string) => {
    let userType = '';
    setSocialUser({ social: 'F', user: { uid: uid, email: email, firstname: firstName, lastname: lastName } });
    const cft: SocialToken = {
      uid: uid,
      token: token,
      email: email,
      userType: userType,
      hunterCode: params.huntercode ? params.huntercode : '',
    };
    await axiosHelper.createFacebookToken(cft).then((response) => {
      if (response.dslUser) {
        tokLogin(response.dslUser.dslToken).then((response) => {
          navigate(`/${ROUTEPATHS.COMMUNITY}/${response?.nameForURL}/profile-editable`);
        });
      } else {
        console.log(response);
        navigate(`/choose-username`);
      }
    });
  };

  const googleSignUp = async (token: string, uid: string, email: string, firstName: string, lastName: string) => {
    let userType = '';
    setSocialUser({ social: 'G', user: { uid: uid, email: email, firstname: firstName, lastname: lastName } });
    const cft: SocialToken = {
      uid: uid,
      token: token,
      email: email,
      userType: userType,
      hunterCode: params.huntercode ? params.huntercode : '',
    };
    await axiosHelper.createGoogleToken(cft).then((response) => {
      console.log(response);

      if (response.dslUser) {
        tokLogin(response.dslUser.dslToken).then((response) => {
          navigate(`/${ROUTEPATHS.COMMUNITY}/${response?.nameForURL}/profile-editable`);
        });
      } else {
        navigate(`/choose-username`);
      }
    });
  };

  return (
    <>
      <AppHeaderWLF links={headerMenu} bgColor="#7997c5" logoImg={headerLogo} bgImage={creative} pageTitle="Signup" hideSearch={true} />
      <main className="container-fluid py-5 bg-light-gray">
        <div className="row col-12 justify-content-center align-items-center ">
          <div className="col-12 col-md-5 col-lg-3  d-flex flex-direction-row align-items-center justify-content-center mb-5">
            <SignupCard
              selected={userType === 'D'}
              onClick={selectDesigner}
              topText="Sign up as a user"
              middleText={`Select the “individual user“ profile if you are:
              1) A creative and you want to participate in our contest.              
              2) A design lover and you want vote a project of a visible gallery contest.
              3) A company employee and you want to join your “company user“ profile.`}
              backGround={creative}
            ></SignupCard>
          </div>
          <div className="col-12 col-md-5 col-lg-3  d-flex flex-direction-row align-items-center justify-content-center mb-5">
            <SignupCard
              selected={userType === 'C'}
              onClick={selectClient}
              topText="Sign up as a client"
              middleText={`Select the “client“ profile only if you represent your company and you want to launch a contest on desall.
            This is a client profile so this profile can’t vote or participate in our contests.`}
              backGround={creative}
            ></SignupCard>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12 col-md-4 col-lg-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-12 text-center">
                  <h1 className="sub-title color-dark my-5">Signup</h1>
                </div>
              </div>
              <div className="row">
                <FormField name="username" label="Username" required error={errors.username} fullWidth>
                  <input
                    type="text"
                    id="username"
                    placeholder="username"
                    autoComplete="username"
                    {...register('username', { required: 'Username is required', minLength: 3, maxLength: 50, validate: validateUsername })}
                  />
                </FormField>
              </div>
              <div className="row">
                <FormField name="email" label="Email" required error={errors.email} fullWidth>
                  <input
                    type="email"
                    id="email"
                    placeholder="email"
                    autoComplete="email"
                    {...register('email', { required: 'Email is required', maxLength: 50, validate: validateEmail })}
                    onChange={(e) => {
                      clearErrors('email'); // clear the error immediately
                    }}
                  />
                </FormField>
              </div>
              <div className="row">
                <FormField name="password" label="Password" required error={errors.password} fullWidth>
                  <input
                    type="password"
                    id="password"
                    placeholder="password"
                    className=""
                    autoComplete="new-password"
                    {...register('password', { required: 'Password is required', minLength: { value: 6, message: 'Password must be at least 6 characters long' } })}
                  />
                </FormField>
              </div>
              <div className="row">
                <FormField name="confirmPassword" label="Confirm Password" required error={errors.confirmPassword} fullWidth>
                  <input
                    type="password"
                    id="confirmPassword"
                    placeholder="repeat password"
                    autoComplete="new-password"
                    {...register('confirmPassword', { required: 'Please confirm your password', validate: (value) => value === watch('password') || 'Passwords do not match' })}
                    onChange={() => clearErrors('confirmPassword')}
                  />
                </FormField>
              </div>

              <div className="row">
                <FormField name="agreement" label="User Agreement" required error={errors.agreement} fullWidth>
                  <div className="d-flex align-items-center">
                    <input type="checkbox" id="checkbox-1" {...register('agreement', { required: 'You must accept the User Agreement' })} className="" />
                    <label htmlFor="checkbox-1" className="d-block text-start ps-3 text">
                      I’m over 18 and agree to the <a href="#">User Agreement</a>
                    </label>
                  </div>
                </FormField>
              </div>
              <div className="row">
                <FormField name="privacy" label="Privacy Policy" required error={errors.privacy} fullWidth>
                  <div className="d-flex align-items-center">
                    <input type="checkbox" id="checkbox-2" {...register('privacy', { required: 'You must accept the Privacy Policy' })} className="" />
                    <label htmlFor="checkbox-2" className="">
                      I agree to the <a href="#">Privacy Policy</a>
                    </label>
                  </div>
                </FormField>
              </div>
              <div className="row">
                <FormField name="receiveNewsletter" label="Newsletter Privacy Policy" fullWidth>
                  <div className="d-flex align-items-center">
                    <input type="checkbox" id="checkbox-3" {...register('receiveNewsletter')} />
                    <label htmlFor="checkbox-3" className="">
                      I want to receive the newsletter and agree to the <a href="#">Privacy policy Newsletter</a>
                    </label>
                  </div>
                </FormField>
              </div>

              <div className="row justify-content-center">
                <div className="col-12 my-5">
                  <button type="submit" className="btn-dark-blue full rounded 3">Signup</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="row text-center justify-content-center">
          <div className="col-12 col-md-3 col-lg-3">
            <h1 className="sub-title color-dark mb-5">or connect with</h1>
            <LoginSocialGoogle
              client_id={process.env.REACT_APP_GG_APP_ID || ''}
              scope="openid profile email"
              onReject={(reject: string | objectType) => {
                console.log(reject);
              }}
              onResolve={({ provider, data }: IResolveParams) => {
                console.log(provider);
                console.log(data);
                socialSignup({ provider, data });
                googleSignUp(data?.access_token, data?.sub, data?.email, data?.given_name, data?.family_name);
              }}
            >
              <button className="btn-social__google full rounded mb-3">
                <div className="btn-icon">
                  <FontAwesomeIcon icon={faGoogle as IconProp} className="text color-light" />
                </div>
                google
              </button>
            </LoginSocialGoogle>
            <LoginSocialFacebook
              appId={process.env.REACT_APP_FB_APP_ID || ''}
              onResolve={({ provider, data }: IResolveParams) => {
                socialSignup({ provider, data });

                console.log(provider);
                console.log(data);
                console.log(data?.accessToken);
                facebookSignUp(data?.accessToken, data?.userID, data?.email, data?.first_name, data?.last_name);
              }}
              onReject={(err: any) => {
                console.log(err);
              }}
            >
              <button className="btn-social__facebook full rounded mb-3">
                <div className="btn-icon">
                  <FontAwesomeIcon icon={faFacebook as IconProp} className="text color-light" />
                </div>
                facebook
              </button>
            </LoginSocialFacebook>
          </div>
        </div>
        <Modal show={clientModalVisible} className={`d-flex flex-column justify-content-center`} contentClassName={` ${styles.rounded}`}>
          <Modal.Body className={`d-flex justify-content-center `}>
            <div className="row justify-content-start align-items-center text-center">
              <div className="col-12">
                <div className="d-flex justify-content-end w-100">
                  <div
                    className={` ${styles.closeButton}`}
                    onClick={() => {
                      setClientModalVisible(false);
                      selectDesigner();
                      // hideLoginPopup();
                      // props.callback(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faXmark as IconProp} className=" text color-light " />
                  </div>
                </div>
              </div>
              <div className="col-12 mb-4">
                <span className="bigger-text-bold ">Warning</span>
              </div>

              <div className="col-12 mb-4 justify-content-center d-flex">
                <span className="sub-title ">Are you going to launch a contest on desall.com?</span>
              </div>

              <div className="row text-center ">
                <div>
                  Pick the “client“ profile only if you represent your company and you want to launch a contest on desall.
                  <br />
                  The “client“ profile can’t vote or participate in our contests.
                </div>
              </div>
              <div className="row text-center justify-content-center mt-5">
                <div className="btn-dark-blue rounded  col-4" onClick={selectClient}>
                  Confirm
                </div>
              </div>
            </div>

            {/* <h5>You will be redirected to the Artsana platform innovation.artsana.com</h5> */}
          </Modal.Body>
        </Modal>
      </main>

      <AppFooter links={footerMenu} bgColor="#304053" logoImg={headerLogo} bgImage={footerImg} />
    </>
  );
};

export default SignupPage;
